// 留言附件在內文裡的 markup。
//
// 形式跟 GitLab 一樣是 [檔名](連結),但**括號裡放的是附件 id,不是 URL**:
//
//     [需求規格.docx](wi-attachment:123)
//
// 為什麼不能存 URL:附件放在 private 的 ticket-attachments bucket,取用要 signed URL,
// 而 signed URL 一小時就過期 —— 寫進內文的話舊留言的附件明天就打不開。換成 public
// bucket 則是免登入就能下載公司文件,風險更大。存 id、渲染時才即時換 signed URL,
// 連結不會過期也不會外洩,日後換 bucket 也不用動任何一筆舊留言。
//
// 慣例對齊 mention 的 @[名字](uuid):內文存 id、顯示存名字。

const RE_SOURCE = '\\[([^\\]]*)\\]\\(wi-attachment:(\\d+)\\)';

/** 產生 markup。檔名裡的 [] 會被拿掉,避免破壞 markdown 結構。 */
export const buildAttachmentMarkup = (fileName, attachmentId) =>
  `[${String(fileName || '檔案').replace(/[[\]]/g, '')}](wi-attachment:${attachmentId})`;

/** 取出內文引用到的所有附件 id(去重)。 */
export const parseAttachmentIds = (content) => {
  const re = new RegExp(RE_SOURCE, 'g');
  const ids = [];
  let m;
  while ((m = re.exec(content || '')) !== null) ids.push(Number(m[2]));
  return [...new Set(ids)];
};

/**
 * 通知信 / 摘要用:把 markup 還原成看得懂的文字,不要讓使用者看到裸 markup。
 *
 * 加 📎 前綴是為了讓收信的人一眼知道「這是附件、要進系統下載」。只還原成純檔名的話,
 * 檔名會混在句子裡看起來像漏送了附件。
 * 不放下載連結是刻意的:附件走 signed URL,一小時就過期,寄出去等對方隔天讀就是死連結;
 * 改放長效連結等於把公司文件的永久網址寄出去。信裡本來就有「查看詳情」可以進系統拿。
 */
export const stripAttachmentMarkup = (content) =>
  (content || '').replace(new RegExp(RE_SOURCE, 'g'), '📎 $1');

export const ATTACHMENT_HREF_PREFIX = 'wi-attachment:';
